const toWholeSeconds = (value) => {
    const nextValue = Number(value)

    return Number.isFinite(nextValue) ? Math.trunc(nextValue) : 0
}

const formatTwoDigit = (value) => {
    return String(value).padStart(2, '0')
}

// 초 단위 러닝 시간을 기존 HH:mm:ss 형식으로 표시한다.
export const formatRunDuration = (value) => {
    const totalSeconds = toWholeSeconds(value)
    const hours = Math.trunc(totalSeconds / 3600)
    const minutes = Math.trunc((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return `${formatTwoDigit(hours)}:${formatTwoDigit(minutes)}:${formatTwoDigit(seconds)}`
}

// 초 단위 페이스 값을 기존 mm'ss" 형식으로 표시한다.
export const formatRunPace = (value) => {
    const totalSeconds = toWholeSeconds(value)
    const minutes = Math.trunc((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return `${formatTwoDigit(minutes)}'${formatTwoDigit(seconds)}"`
}
